import EventForm from "."
import AccessCodeWrapper from "@components/ui/AccessCodeWrapper";

const EventAccessCodeForm = () => {

    return (
        <AccessCodeWrapper forceStoreLocalStorageWhenInitial={false}>
            <EventForm />
        </AccessCodeWrapper>
    )

}

export default EventAccessCodeForm